module.exports = __webpack_public_path__ + "img/logo.253c8047.svg";